import * as Yup from "yup";
import { buildPhoneNumberSchema } from "../../pages/ThreePL/shared/phoneValidation";
import { buildCnicSchema } from "../../utils/pakistanCnic";

const stripHtml = (value) =>
  String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\u200B/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const driverFormSchema = Yup.object().shape({
  driverName: Yup.string()
    .trim()
    .min(3, "Driver name must be at least 3 characters")
    .max(100, "Driver name is too long")
    .required("Driver name is required"),
  employeeNumber: Yup.string()
    .trim()
    .required("Employee number is required"),
  cnicNumber: buildCnicSchema("CNIC number is required"),
  contact: buildPhoneNumberSchema("Contact is required"),
  dateOfBirth: Yup.date()
    .nullable()
    .typeError("Date of birth is required")
    .required("Date of birth is required"),
  cnicIssueDate: Yup.date()
    .nullable()
    .typeError("CNIC issue date is required")
    .required("CNIC issue date is required"),
  cnicExpiryDate: Yup.date()
    .nullable()
    .typeError("CNIC expiry date is required")
    .required("CNIC expiry date is required"),
  licenseNumber: Yup.string()
    .trim()
    .min(2, "License number is too short")
    .max(50, "License number is too long")
    .required("License number is required"),
  licenseIssueDate: Yup.date()
    .nullable()
    .typeError("License issue date is required")
    .required("License issue date is required"),
  licenseExpiryDate: Yup.date()
    .nullable()
    .typeError("License expiry date is required")
    .required("License expiry date is required"),
  appAuthCode: Yup.string()
    .trim()
    .when("authMethod", {
      is: (value) => String(value || "").trim().toLowerCase() === "pin",
      then: (schema) =>
        schema
          .matches(/^\d{4,8}$/, "PIN auth code must be 4 to 8 digits")
          .required("App auth code is required"),
      otherwise: (schema) =>
        schema
          .min(3, "App auth code is too short")
          .max(50, "App auth code is too long")
          .required("App auth code is required"),
    }),
  authMethod: Yup.string().trim().required("Auth method is required"),
  baseSalary: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || originalValue === undefined
        ? NaN
        : value
    )
    .typeError("Base salary must be a number")
    .min(0, "Base salary must be 0 or greater")
    .required("Base salary is required"),
  salaryTerms: Yup.string().trim().required("Salary terms are required"),
  casualLeaveQuota: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || originalValue === undefined
        ? NaN
        : value
    )
    .integer("Casual leave quota must be a whole number")
    .min(0, "Casual leave quota must be 0 or greater")
    .required("Casual leave quota is required"),
  annualLeaveQuota: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || originalValue === undefined
        ? NaN
        : value
    )
    .integer("Annual leave quota must be a whole number")
    .min(0, "Annual leave quota must be 0 or greater")
    .required("Annual leave quota is required"),
  sickLeaveQuota: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || originalValue === undefined
        ? NaN
        : value
    )
    .integer("Sick leave quota must be a whole number")
    .min(0, "Sick leave quota must be 0 or greater")
    .required("Sick leave quota is required"),
  paternityLeaveQuota: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || originalValue === undefined
        ? NaN
        : value
    )
    .integer("Paternity leave quota must be a whole number")
    .min(0, "Paternity leave quota must be 0 or greater")
    .required("Paternity leave quota is required"),
  notes: Yup.string()
    .nullable()
    .test("notes-max", "Notes are too long", (value) => stripHtml(value).length <= 1500),
  supervisorId: Yup.mixed()
    .nullable()
    .test(
      "supervisor-required",
      "Driver supervisor is required",
      (value) => value !== null && value !== "" && value !== undefined
    )
    .required("Driver supervisor is required"),
  attachments: Yup.array().nullable(),
});
